module.exports = "<div class=\"terms-wrapper\">\n  <div class=\"terms-inner\">\n    <div class=\"terms-header\">\n      Terms of Service\n    </div>\n    <div class=\"terms-sub\">\n      {{ termsVersion }}\n    </div>\n    <div class=\"terms-body\" [innerHTML]=\"termsHTML\"></div>\n    <footer></footer>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/terms/terms.component.html
// module id = ../../../../../src/app/terms/terms.component.html
// module chunks = main